/**
 * Metadata van het mystieke circuit (de mystieke weg / mystieke stroom uit
 * Rave Cosmology II, The Six Mystical Ways), voor het mystiek-paneel, de
 * klikbare mystiek-iconen en de sectie in de circuits-tab van de editor.
 *
 * Het circuit loopt als één stroom van de wortel naar de keel over acht
 * poorten. De volgorde hieronder is de stroomvolgorde (niet numeriek): elke
 * overgang kruist een centrum (49 → 37 de solar plexus, 40 → 51 het hart,
 * 25 → 10 de G).
 */
export const HD_MYSTICAL_CIRCUIT_GATES: readonly number[] = [19, 49, 37, 40, 51, 25, 10, 20];

/** Is dit een poort van het mystieke circuit (en dus een sectie in het paneel)? */
export function hdIsMysticalCircuitGate(gate: number): boolean {
  return HD_MYSTICAL_CIRCUIT_GATES.includes(gate);
}

/** De vijf bewegingen van de stroom, elk met zijn poorten in stroomvolgorde. */
export type HdMysticalStage = 'pressure' | 'touch' | 'power' | 'love' | 'expression';

export const HD_MYSTICAL_STAGES: readonly { readonly stage: HdMysticalStage; readonly gates: readonly number[] }[] = [
  { stage: 'pressure', gates: [19] },
  { stage: 'touch', gates: [49, 37] },
  { stage: 'power', gates: [40, 51] },
  { stage: 'love', gates: [25, 10] },
  { stage: 'expression', gates: [20] },
];

/**
 * Circuit-indicatorkleur per poort (rail van het blokje), gelijk aan de
 * circuit-source-of-truth (`HD_BODYGRAPH_CIRCUITS`), net als bij het
 * geheugencircuit: 19-49 en 37-40 tribaal-ondernemend #F01C1C, 51-25
 * individueel-centrerend #00B9CE, 10-20 individueel-integratie #00522B.
 */
export const HD_MYSTICAL_GATE_COLOR: Readonly<Record<number, string>> = {
  19: '#F01C1C', 49: '#F01C1C', 37: '#F01C1C', 40: '#F01C1C',
  51: '#00B9CE', 25: '#00B9CE',
  10: '#00522B', 20: '#00522B',
};

/** Paneel-key van het mystiek-paneel (dedup in de FloatingPanelService). */
export const HD_MYSTICAL_PANEL_KEY = 'mystical-circuit';

/** FA-icoon van het mystieke circuit (gelijk aan het poort-eigenschap-icoon `mystical`). */
export const HD_MYSTICAL_ICON = 'hand-sparkles';

/** `FLOATING_PANEL_DATA` van het mystiek-paneel. */
export interface HdMysticalPanelData {
  /** Poort waar het paneel na openen naartoe scrollt, of `null`. */
  readonly focusGate: number | null;
}
